<template>
      <div no-body class="lku-item"> 
      <b-form-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-form-row>
      <b-form-row v-else>
        <b-input-group>
            <b-input-group-prepend><label style="width:60px !important;">Filter</label></b-input-group-prepend>
            <b-form-input v-model="tblData.itemname" placeholder="Name" @keyup.13.native="refresh()" style="width:30% !important;"></b-form-input>
            <b-form-input v-model="tblData.itemcode" placeholder="Code" value="" @keyup.13.native="refresh()" class="ml-1" ></b-form-input>
            <b-input-group-append><span class="p-2">Active</span></b-input-group-append>
            <b-form-select v-model="tblData.isactive" :plain="true" :options="activeStatus" :disabled="(isactive=='1')" size="sm"></b-form-select>
        </b-input-group>
        <b-input-group >
            <b-input-group-prepend><label style="width:60px !important;">Category</label></b-input-group-prepend>
            <b-form-select v-model="tblData.itemcategory" :plain="true" :options="itemCategories" style="width:20% !important;" size="sm"> </b-form-select>
            <b-input-group-append><span class="input-group-text">Head </span></b-input-group-append>
            <b-form-select v-model="tblData.headcategory" :plain="true" :options="headCategories" style="width:20% !important;" size="sm"></b-form-select>
            <b-input-group-append><span class="pl-2 pt-2">Material</span></b-input-group-append>
            <b-form-select v-model="tblData.jasa" :plain="true" :options="jasaMaterial" :disabled="(jasa)" size="sm"></b-form-select>
            <b-input-group-append>
                <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
            </b-input-group-append>
        </b-input-group>
      </b-form-row>      
      <b-table
          class="m-0"
          ref="tblItem"
          responsive striped hover small
          style="font-size:smaller;" 
          :items="tblData.items"
          :fields="fields"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="updatetable" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(jasa)="data">
            <span v-if="(data.item.jasa==1)">Service</span>
            <span v-else>Material</span>
          </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-item {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import item from "../../apis/item";

export default {
  data() {
    return {
      fields: [
          {
            key: "partnumber",
            label: "Item Code",
            sortable: true
          },
          {
            key: "jasa",
            label: "_",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "invunitom",
            thStyle: "width:80px",
            label: "UnitSize"
          },          
          {
            key: "qtyAvail",
            label: "Inventory",
            sortable: true
          },          
          {
            key: "qtyReserved",
            label: "Reserved",
            sortable: true
          },          
          {
            key: "nmcategory",
            label: "Category",
            sortable: true
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'itemname',
        sortDesc: false,
      },
      updatetable:false,
      activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Discontinued' },{ value: '1', text: 'Active/In Use' }],
      jasaMaterial : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Material ' },{ value: '1', text: 'Service' }],
      lkuLoading:false,
      itemCategories:[], headCategories:[]
    };
  },
  props: ['jasa','isactive',`formdata`],
  created: async function() {
      this.tblData.jasa=this.jasa || '';
      this.tblData.isactive=this.isactive || '';
      if (this.formdata.items)
      {
          for (var key in this.formdata) {
              this.tblData[key] = this.formdata[key];
          }
      } else {
        const [a,b] = await Promise.all([item.headgroup(),item.group(),this.data()]) ;
        this.headCategories = a.reduce((newArr,item) =>{
            newArr.push({ value: item.value, text: item.text});
            return newArr;
        },[{value:'', text:'--- ALL ---'}]);
        this.itemCategories = b.reduce((newArr,item) =>{
            newArr.push({ value: item.value, text: item.text});
            return newArr;
        },[{value:'', text:'--- ALL ---'}]);        
      }
  },
  watch: {
    "tblData.page": function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    "tblData.limit": function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.lkuLoading = false;
    },
    data: async function(ctx) {
      if(this.jasa){
        this.tblData.jasa = this.jasa; 
      }
      if(this.isactive){
        this.tblData.isactive = this.isactive; 
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      const items= await item.listsaldo(this.tblData);    
      this.lkuLoading = false;
      this.tblData.items = items;      
      this.updatetable=!this.updatetable;
    },
    selectItem(item,index) {
      // this.$emit("click", item);
      this.tblData.selected=item;
      this.$emit("click", this.tblData);
    },
    clearFilter() {
        this.tblData.itemcode=  '';
        this.tblData.itemname=  '';
        this.tblData.headcategory=  '';
        this.refresh();
    },    
    refresh() {
       this.data();
      this.$refs.tblItem.refresh();
    }
  }
};
</script>
